import { createContext, useCallback, useRef, useState } from "react";

export type DictationValue = {
  activeKey: string | undefined;
  setActiveKey: (value?: string) => void;
  registerStopCallback: (cb: () => void) => () => void;
  stopActiveDictation: () => void;
};

const defaultApi: DictationValue = {
  activeKey: undefined,
  setActiveKey: () => null,
  registerStopCallback: () => () => {},
  stopActiveDictation: () => {},
};

export const DictactionContext = createContext<DictationValue>(defaultApi);

export function DictactionProvider({ children }: any) {
  const [activeKey, setActiveKey] = useState<string>();
  const stopCallbackRef = useRef<(() => void) | null>(null);

  const _setActiveKey = (value?: string) => {
    setActiveKey(value);
  };

  const registerStopCallback = useCallback((cb: () => void) => {
    stopCallbackRef.current = cb;
    return () => {
      if (stopCallbackRef.current === cb) {
        stopCallbackRef.current = null;
      }
    };
  }, []);

  const stopActiveDictation = useCallback(() => {
    stopCallbackRef.current?.();
  }, []);

  const api: DictationValue = {
    activeKey,
    setActiveKey: _setActiveKey,
    registerStopCallback,
    stopActiveDictation,
  };

  return (
    <DictactionContext.Provider value={api}>
      {children}
    </DictactionContext.Provider>
  );
}
